<template>
  <div id="app" :class="[ isSelect ? 'theme-dark' : '' ]">
    <f7-statusbar></f7-statusbar>
    <f7-view id="main-view" url="/" main :pushState="true"></f7-view>
  </div>
</template>

<script>
export default {
    //props: ['isSelect'],
    data() {
        return {
            isSelect: true,
        }
    }
}
</script>

<style>
    .md .item-divider, .md .list-group-title {
        font-size: 16px;
        font-weight: bold;
    }
    .md .list {
        margin: 0 0 32px 0;
        font-size: 16px;
    }
    .md .block-title {
        color: #fff;
        font-weight: bold;
        font-family: sans-serif;
        font-size: 20px;
    }
    .md .calendar-day.calendar-day-today span {
        color: #e91e63;
    }
    .md .calendar-day.calendar-day-selected span {
        background: #e91e63;
        color: #fff;
    }
    .theme-dark .toolbar {
        background: #171717 !important;
    }
    .theme-dark .tabbar a.tab-link, .theme-dark .tabbar-labels a.tab-link {
        color: #ddd !important;
    }
    .theme-dark .tabbar a.tab-link.tab-link-active, .theme-dark .tabbar-labels a.tab-link.tab-link-active, 
    .theme-dark .tabbar a.tab-link.active-state, .theme-dark .tabbar-labels a.tab-link.active-state {
        color: #e91e63 !important;
    }
    .md .page.theme-dark {
        color: rgba(255, 255, 255, 0.87);
        background: #282829;
        contain: strict;
    }
    .md .navbar {
        height: 56px;
        background: #e91e63;
        color: #fff;
        font-size: 20px;
    }
    .md label.item-radio input[type="radio"]:checked ~ .icon-radio, .md label.item-radio input[type="radio"]:checked ~ * .icon-radio, .md .radio input[type="radio"]:checked ~ .icon-radio {
        border-color: #e91e63;
    }
    .md label.item-radio input[type="radio"]:checked ~ .icon-radio:after, .md label.item-radio input[type="radio"]:checked ~ * .icon-radio:after, .md .radio input[type="radio"]:checked ~ .icon-radio:after {
        background-color: #e91e63;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
</style>



// WEBPACK FOOTER //
// src/app.vue